import { EditMajorV1EventPage } from "./EditMajorV1EventPage";

export default EditMajorV1EventPage;
